import React from 'react';
// import FormOne from '../contact/FormOne';


const AboutOne = () => {
    return (
        <section className="section section-padding-equal bg-color-light">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="about-us">
                            <div className="section-heading heading-left mb-0">
                                <span className="subtitle">About Graphify Infotech</span>
                                <h2 className="title mb--40">Building Digital Solutions, Driving Business Growth</h2>
<p>Graphify Infotech, based in Coimbatore, is your trusted partner in the digital landscape. We specialize in web and mobile app development, digital marketing, SEO, and e-learning platforms — blending creativity and technology to transform ideas into success. Together, let’s build your digital future.</p>                            </div>
                        </div>
                    </div>

                    <div className="col-xl-5 col-lg-6 offset-xl-1">
                        <div className="contact-form-box">
                            <h1 className="title">Your Vision,<br/> Our Technology</h1>
                           {/* <FormOne /> */}
                        </div>
                    </div>
                </div>
            </div>
            <ul className="shape-group-6 list-unstyled">
                <li className="shape shape-1"><img src={"/images/others/bubble-7.png"} alt="Bubble" /></li>
                <li className="shape shape-2"><img src={"/images/others/line-4.png"} alt="line" /></li>
                <li className="shape shape-3"><img src={"/images/others/line-5.png"} alt="line" /></li>
            </ul>
        </section>
    )
}

export default AboutOne;